export default __webpack_public_path__ + "static/media/bigLogo.0e2cbf9f.svg";